import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

@Component({
	selector: 'app-modal-info',
	templateUrl: './modal-info.component.html',
	styleUrls: ['./modal-info.component.styl'],
})
export class PixKeysCreateModalInfoComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<PixKeysCreateModalInfoComponent>,
	) {
	}

	ngOnInit(): void {
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/create/modal-info/modal-info.component.ts